export interface Promotion {
  promotion: any;
}

export const initialpromotionState: Promotion = {
  promotion: {},
};
